

import { Alert } from "./Alert";

import { useEffect } from "react";
import { useToaster } from "rsuite";

export const AlertBridge = () => {
    const toaster = useToaster();

    useEffect(() => {
        Alert.setToaster(toaster);

        return () => {
            Alert.setToaster(null);
        };
    }, [toaster]);

    return null;
};
